// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Ijli","question":"Question_question__2eN-_","description":"Question_description__ibQxO"};